import { render, staticRenderFns } from "./Pagamentos.vue?vue&type=template&id=3c7d1b92&scoped=true&"
import script from "./Pagamentos.vue?vue&type=script&lang=js&"
export * from "./Pagamentos.vue?vue&type=script&lang=js&"
import style0 from "./Pagamentos.vue?vue&type=style&index=0&id=3c7d1b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d1b92",
  null
  
)

export default component.exports